// import React from 'react';
// import ReusableTabs from '../../../pages/ReusableTabs';
// import UploadSection from './Sections/UploadSection';
// import LibrarySection from './Sections/LibrarySection';
// import AuditSection from './Sections/AuditSection';

// const EngineeringPanel = () => {
//   const tabs = [
//     { label: 'UPLOAD', component: <UploadSection /> },
//     { label: 'LIBRARY', component: <LibrarySection /> },
//     { label: 'AUDITS', component: <AuditSection /> },
//   ];

//   return (
//     <div>
//       <ReusableTabs
//         tabs={tabs}
//         defaultTab={0}
//         panelStyles={{ padding: '16px' }}
//       />
//     </div>
//   );
// };

// export default EngineeringPanel;

import React, { useState, useEffect } from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import UploadSection from './Sections/UploadSection';
import LibrarySection from './Sections/LibrarySection';
import AuditSection from './Sections/AuditSection';

const EngineeringPanel = () => {
  const [canEditEngineering, setCanEditEngineering] = useState(false);

  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanEditEngineering(roles.includes("SD_Engineering_Edit"));
    }
  }, []);

  const tabs = [
    ...(canEditEngineering
      ? [{ label: 'UPLOAD', component: <UploadSection /> }]
      : []
    ),
    { label: 'LIBRARY', component: <LibrarySection /> },
    { label: 'AUDITS', component: <AuditSection /> },
  ];

  return (
    <div>
      <ReusableTabs
        tabs={tabs}
        defaultTab={0}
        panelStyles={{ padding: '16px' }}
      />
    </div>
  );
};

export default EngineeringPanel;